import React from 'react'
import bigLogo from 'theme/images/logo.svg'
import smallLogo from 'theme/images/logo-small.svg'

const Logo = ({ isSmallIcon }) => (
  <img src={isSmallIcon ? smallLogo : bigLogo} alt="Logo" height={35} />
)

export default Logo
